interface ChatSuggestionsProps {
  suggestions: string[];
  onSelect: (text: string) => void;
}

export function ChatSuggestions({ suggestions, onSelect }: ChatSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-end gap-2 px-6 pb-3">
      {suggestions.map((text) => (
        <button
          key={text}
          type="button"
          onClick={() => onSelect(text)}
          className="rounded-full border border-border px-3.5 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent dark:border-white/[0.1] dark:text-white/80 dark:hover:bg-white/[0.06]"
        >
          {text}
        </button>
      ))}
    </div>
  );
}
